/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */

 // PS_01 | SQ_EX_1.0 - Import React and necessary hooks
import React, { useState, useEffect } from "react"; 

// PS_02 | SQ_EX_2.0 - Import required interfaces
import {
  ManageUsersListGridData,
  ManageUsersListRequest,
  ToastInterface,
  usersGridSortOrderInterfaceType,
} from "../../Interface/ManageClient"; 

 // PS_03 | SQ_EX_3.0 - Import API service functions
import {
  fetchUsersListGridDataService,
  postInviteUpdateClientService,
} from "../../Service/ManageClients/ManageClientsService";
// import Toast from "./Toaster";

// PS_04 | SQ_EX_4.0 - Import Loader component
import Loader from "../Loader";

// PS_05 | SQ_EX_5.0 - Define UsersGrid component with props
const UsersGrid: ({
  customerUUID,
  setCallUserGridAPI,
  isPilotActive,
  setToastDetails,
}: {
  customerUUID: string;
  setCallUserGridAPI: React.Dispatch<React.SetStateAction<string>>;
  isPilotActive: boolean;
  setToastDetails: React.Dispatch<React.SetStateAction<ToastInterface>>
}) => JSX.Element = ({
  customerUUID,
  setCallUserGridAPI,
  isPilotActive,
  setToastDetails,
}: {
  customerUUID: string;
  setCallUserGridAPI: React.Dispatch<React.SetStateAction<string>>;
  isPilotActive: boolean;
  setToastDetails: React.Dispatch<React.SetStateAction<ToastInterface>>
}) => {

   // PS_07 | SQ_EX_7.0 - Initialize payload data
  const payloadInitialData: ManageUsersListRequest = {
    customer_uuid: customerUUID,
    search: "",
    sort: {
      column: "",
      order: "desc",
    },
    load_more: 20,
  };

   // PS_08 | SQ_EX_8.0 - Set initial sort order
  const initialSortOrder: usersGridSortOrderInterfaceType = {
    user_name: false,
    phone_number: false,
  };

  // const initialToastDetails: ToastInterface = {
  //   isToast: false,
  //   toastDescription: "",
  //   toastMessage: "",
  //   toastType: "",
  // };

   // PS_06 | SQ_EX_6.0 - Initialize state variables
  const [usersGridData, setUsersGridData] = useState<ManageUsersListGridData[]>(
    [] as ManageUsersListGridData[]
  ); // PS_06 | SQ_EX_6.0
  const [tempUsersGridData, setTempUsersGridData] = useState<
    ManageUsersListGridData[]
  >([] as ManageUsersListGridData[]); // PS_06 | SQ_EX_6.0
  const [usersGridPayload, setUsersGridPayload] =
    useState<ManageUsersListRequest>(payloadInitialData);
  const [sortOrder, setSortOrder] =
    useState<usersGridSortOrderInterfaceType>(initialSortOrder);
  const [loadMore, setLoadMore] = useState<number>(20);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [primaryUserData, setPrimaryUserData] =
    useState<ManageUsersListGridData>({} as ManageUsersListGridData);
  const [deletePopup, setDeletePopup] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  // const [toastDetails, setToastDetails] =
  //   useState<ToastInterface>(initialToastDetails);
  const [callGrid, setCallGrid] = useState<string>("");

  // PS_09 | SQ_EX_9.0 - Effect to fetch data when payload changes
  useEffect(() => {
    fetchData();
  }, [usersGridPayload]); 

  // PS_10 | SQ_EX_10.0 - Effect to fetch data when callGrid is "call"
  useEffect(() => {
    if (callGrid === "call") {
      fetchData();
    }
  }, [callGrid]);

  // PS_11 | SQ_EX_11.0 - Function to fetch user grid data
  const fetchData = async (search = "") => {
    try {

      // PS_12 | SQ_EX_12.0 - Set loading state
      setIsLoading(true);

      // PS_13 | SQ_EX_13.0 - Prepare payload for API call
      let usersGridPayloadObj: ManageUsersListRequest = {
        ...usersGridPayload,
        customer_uuid: customerUUID,
      };
      
      // Create a new URLSearchParams object
      const params = new URLSearchParams();

        // PS_14 | SQ_EX_14.0 - Create URL parameters
      // Append optional search term
      if (usersGridPayloadObj.search) {
        params.append("search", usersGridPayloadObj?.search);
      }

      // Append sorting information if provided
      if (usersGridPayloadObj.sort.column) {
        params.append("column", usersGridPayloadObj.sort.column);
      }
      if (usersGridPayloadObj.sort.order) {
        params.append("order", usersGridPayloadObj.sort.order);
      }

      // Append load_more for pagination
      if (usersGridPayloadObj.load_more) {
        params.append("load_more", usersGridPayloadObj.load_more.toString());
      }

       // PS_15 | SQ_EX_15.0 - Set call user grid API if necessary
      if (callGrid === "call") {
        setCallUserGridAPI("call");
      }

        // PS_16 | SQ_EX_16.0 - Call API to fetch user grid data
      const response = await fetchUsersListGridDataService(
        usersGridPayloadObj.customer_uuid,
        params.toString()
      );

        // PS_17 | SQ_EX_17.0 - Handle successful response
      if (response?.status === "Success" && response.code === 200) {
        if (response?.meta?.total_count !== undefined) {
          setTotalCount(response?.meta?.total_count);
        }
        setUsersGridData(response?.data);
      }

      // PS_18 | SQ_EX_18.0 - Set loading state to false
      setIsLoading(false);
    } catch (error) {
         // PS_19 | SQ_EX_19.0 - Handle and log errors
      console.log("Error while fetching the invoice dynamic data :", error);
    } finally {
        // PS_20 | SQ_EX_20.0 - Reset states after API call
      // setToastDetails(initialToastDetails)
      setIsLoading(false);
      setCallGrid("");
      setCallUserGridAPI("");
    }
  };

   // PS_21 | SQ_EX_21.0 - Function to post invite update
  const postInviteUpdateClient = async (payload: any) => {
    try {
      // PS_22 | SQ_EX_22.0 - Set loading state
      setIsLoading(true);

      // PS_23 | SQ_EX_23.0 - Call API to post invite update
      const response = await postInviteUpdateClientService(payload);
      // setIsLoading(false);

        // PS_24 | SQ_EX_24.0 - Handle successful response
      if (response?.code === 200) {
        setToastDetails((prevState) => ({
          ...prevState,
          isToast: true,
          toastDescription: response?.message,
          toastMessage: "Success",
          toastType: "success",
        }));
      }
      setCallGrid("call");
    } catch (error) {

       // PS_25 | SQ_EX_25.0 - Handle and log errors
      console.error("Error in deleting invoice form data", error);
      setToastDetails((prevState) => ({
        ...prevState,
        isToast: true,
        toastDescription: "Failed",
        toastMessage: "Fail",
        toastType: "error",
      }));
    } finally {
        // PS_26 | SQ_EX_26.0 - Reset loading state
      // setIsLoading(false);
      // setCallUserGridAPI("call");
    }
  };

  // PS_27 | SQ_EX_27.0 - Function to handle sorting
  //handleSort function for sorting
  const handleSort: (column: string, order: boolean) => void = (
    column: string,
    order: boolean
  ) => {
    setUsersGridPayload({
      ...usersGridPayload,
      sort: {
        column,
        order: order ? "asc" : "desc",
      },
    });
  };

   // PS_28 | SQ_EX_28.0 - Function to handle loading more data
  //handleLoadMore function for loading more data
  const handleLoadMore = () => {
    // PS_57 | SQ_EX_57.0, PS_58 | SQ_EX_58.0
    const incrementLoadmore = loadMore + 20;
    setLoadMore(incrementLoadmore);
    setUsersGridPayload((prevPayload) => ({
      ...prevPayload,
      load_more: incrementLoadmore,
    })); // PS_59 | SQ_EX_59.0
  };

   // PS_29 | SQ_EX_29.0 - Function to handle PostInviteUpdate Customer data
  function deletedInvoiceData() {
    let payload = {
      post_type: "set_primary",
      pilot_account_uuid: primaryUserData.pilot_account_uuid,
      customer_uuid: primaryUserData.customer_uuid,
    };
    postInviteUpdateClient(payload);
    setTempUsersGridData([] as ManageUsersListGridData[]);
    setPrimaryUserData({} as ManageUsersListGridData);
    setDeletePopup(false);
  }

    // PS_30 | SQ_EX_30.0 - Function to bind grid data
  const BindGridData = () => {
    return usersGridData?.map((e: ManageUsersListGridData, index: number) => (
      <tr key={index}>
        <td className="ps-4">
          {e?.user_name.trim() === "" ? "-" : e?.user_name}
        </td>
        <td>{e?.phone_number === "" ? "-" : e?.phone_number}</td>
        <td>{e?.business_email === "" ? "-" : e?.business_email}</td>
        <td
          className="text-center"
          style={
            e?.status === "Invite Sent"
              ? { color: "#EF7474" }
              : e?.status === "Active"
              ? { color: "#1F9C3A" }
              : e?.status === "Inactive"
              ? { color: "#F37979" }
              : {}
          }
        >
          {e?.status === "" ? "-" : e?.status}
        </td>
        <td className="text-center">
          <>
            {/* <label className="toggle-switch"> */}
            <div className="form-check form-switch">

            
            <label>
              <input
                className="form-check-input px-3 py-2 custom-toggle"
                type="checkbox"
                checked={e?.admin}
                role="switch"
                id="flexSwitchCheckChecked"
                disabled={
                  isPilotActive
                    ? e?.admin
                      ? true
                      : e?.status?.toLowerCase() !== "active"
                      ? true
                      : false
                    : true
                }
                onClick={() => {
                  setTempUsersGridData(usersGridData);
                  setUsersGridData((prev) =>
                    prev.map((ele: ManageUsersListGridData) =>
                      e?.customer_uuid === ele?.customer_uuid
                        ? { ...ele, admin: true }
                        : { ...ele, admin: false }
                    )
                  );
                  setPrimaryUserData(e);
                  setDeletePopup(true);
                }}
              />

              {/* <input
                type="checkbox"
                checked={e?.admin}
                disabled={
                  isPilotActive
                    ? e?.admin
                      ? true
                      : e?.status?.toLowerCase() !== "active"
                      ? true
                      : false
                    : true
                }
                onClick={() => {
                  setTempUsersGridData(usersGridData);
                  setUsersGridData((prev) =>
                    prev.map((ele: ManageUsersListGridData) =>
                      e?.customer_uuid === ele?.customer_uuid
                        ? { ...ele, admin: true }
                        : { ...ele, admin: false }
                    )
                  );
                  setPrimaryUserData(e);
                  setDeletePopup(true);
                }}
              /> */}
              {/* <span className="slider"></span> */}
            </label>
            </div>
          </>
        </td>
        <td>
          <div className="d-flex align-items-center gap-3 justify-content-center">
            {e?.status?.toLowerCase() === "active" && (
              <button
                className="btn green-btn px-4 font-12 font-semibold"
                disabled={isPilotActive ? e?.is_primary : true}
                onClick={() => {
                  postInviteUpdateClient({
                    post_type: "user_status",
                    customer_uuid: e?.customer_uuid,
                    is_mark_active: false,
                  });
                }}
              >
                Revoke Access
              </button>
            )}
            {e?.status?.toLowerCase() === "inactive" && (
              <button
                className="btn green-btn px-4 font-12 font-semibold"
                disabled={isPilotActive ? false : true}
                onClick={() => {
                  postInviteUpdateClient({
                    post_type: "user_status",
                    customer_uuid: e?.customer_uuid,
                    is_mark_active: true,
                  });
                }}
              >
                Provide Access
              </button>
            )}
            {e?.status?.toLowerCase() === "invite sent" && (
              <button
                disabled
                className="btn green-btn px-4 font-12 font-semibold"
              >
                Revoke Access
              </button>
            )}
          </div>
        </td>
      </tr>
    ));
  };


   // PS_31 | SQ_EX_31.0 - Render component
  return isLoading ? (
    <Loader />
  ) : (
    <>
      <div className="container-fluid p-0 cust-invoive-grid-padding">
        <div className="d-flex align-items-center justify-content-between flex-wrap">
          {/* <h2 className="color-black font-18 font-bold">User's List</h2> */}
          {/* <div className="d-flex align-items-center justify-content-md-center gap-3 flex-wrap mt-2 mt-md-0">
              <div className="position-relative">
                <input
                  type="search"
                  className=" custom-input-search font-14 font-medium color-black custom-search"
                  placeholder="Search here"
                  value={searchValue}
                  onChange={(e) => {
                    setSearchValue(e.target.value);
                  }}
                  onKeyDown={(e) => {
                    handleSearch(e);
                  }}
                />
                <button
                  className="btn bg-transparent border-0 focus-none search-icon"
                  onClick={() => {
                    handleSearchTerms();
                  }}
                >
                  <img
                    className="tab-icon"
                    src="../images/search-icon.svg"
                    alt="search"
                    // onClick={()=>{setInvoiceGridData(invoiceGridData)}}
                  />
                </button>
              </div>
              {/* {contextValue?.userDetails?.is_primary && ( */}
          {/* <button
                className="btn border-0 d-flex align-items-center gap-3 color-white font-semibold font-14 primary-btn px-4 rounded-3"
                // onClick={() => { setEditInvoice(initialFormData); setIsEditInvoice(false); setShowInvoicePopup(true) }}
                onClick={() => {
                  setInvitePopUp(true);
                }}
                disabled={!contextValue?.userDetails?.is_primary}
              >
                <img src="../images/plus-white-icon.svg" alt="Plus Icon" />
                Invite User
              </button> */}
          {/* )} */}
          {/* </div> */}
          <div className="table-responsive theme-table bg-white custom-scroll my-4 w-100">
            {usersGridData?.length > 0 ? (
              <table className="table table-borderless mb-0 acc-view">
                <thead>
                  <tr>
                    <th className="ps-4 text-nowrap">
                      User Name
                      <span className="ms-1 cursor-pointer">
                        <img
                          src={`../images/${
                            sortOrder.user_name
                              ? "sort-up-icon"
                              : "sort-arrow-down"
                          }.svg`}
                          alt={`${
                            sortOrder.user_name
                              ? "sort-up-icon"
                              : "sort-arrow-down"
                          }`}
                          onClick={() => {
                            setSortOrder((prevState) => ({
                              ...prevState,
                              user_name: !prevState.user_name,
                            }));
                            handleSort("user_name", sortOrder.user_name);
                          }}
                        />
                      </span>
                    </th>
                    <th className="text-nowrap">
                      Phone {"#"}
                      <span className="ms-1 cursor-pointer">
                        <img
                          src={`../images/${
                            sortOrder.phone_number
                              ? "sort-up-icon"
                              : "sort-arrow-down"
                          }.svg`}
                          alt={`${
                            sortOrder.phone_number
                              ? "sort-up-icon"
                              : "sort-arrow-down"
                          }`}
                          onClick={() => {
                            setSortOrder((prevState) => ({
                              ...prevState,
                              phone_number: !prevState.phone_number,
                            }));
                            handleSort("phone_number", sortOrder.phone_number);
                          }}
                        />
                      </span>
                    </th>
                    <th className="text-nowrap">
                      Email ID
                      {/* <span className="ms-1 cursor-pointer">
                          <img
                            src={`../images/${
                              sortOrder.invoice_amount
                                ? "sort-up-icon"
                                : "sort-arrow-down"
                            }.svg`}
                            alt={`${
                              sortOrder.invoice_amount
                                ? "sort-up-icon"
                                : "sort-arrow-down"
                            }`}
                            onClick={() => {
                              setSortOrder((prevState) => ({
                                ...prevState,
                                invoice_amount: !prevState.invoice_amount,
                              }));
                              handleSort(
                                "invoice_amount",
                                sortOrder.invoice_amount
                              );
                            }}
                          />
                        </span> */}
                    </th>
                    <th className=" text-nowrap text-center">
                      Status
                      {/* <span className="ms-1 cursor-pointer">
                          <img
                            src={`../images/${
                              sortOrder.invoice_status_name
                                ? "sort-up-icon"
                                : "sort-arrow-down"
                            }.svg`}
                            alt={`${
                              sortOrder.invoice_status_name
                                ? "sort-up-icon"
                                : "sort-arrow-down"
                            }`}
                            onClick={() => {
                              setSortOrder((prevState) => ({
                                ...prevState,
                                invoice_status_name:
                                  !prevState.invoice_status_name,
                              }));
                              handleSort(
                                "invoice_status_name",
                                sortOrder.invoice_status_name
                              );
                            }}
                          />
                        </span> */}
                    </th>
                    <th className=" text-nowrap text-center">Primary</th>
                    <th className=" text-nowrap text-center">Action</th>
                  </tr>
                </thead>
                <tbody>{BindGridData()}</tbody>
              </table>
            ) : (
              <div className="d-flex align-items-center justify-content-center p-5 flex-column">
                <img
                  className="no-record-img no-record-img-client-profile"
                  src="../images/no-record.gif"
                  alt="No record"
                />
                {/* <img src="../images/no-record.svg" alt="no-record"> */}
                <p className="font-medium font-20 color-grey-v1 mb-0 mt-3 text-center">
                  It looks like there are no records to display
                </p>
              </div>
            )}
          </div>
          {usersGridData?.length !== 0 && (
            <p className="font-14 font-medium color-grey-v7">
              Showing{" "}
              <span className="font-semibold color-black">
                {usersGridData?.length}
              </span>{" "}
              out of{" "}
              <span className="font-semibold color-black">{totalCount}</span>{" "}
              Item
            </p>
          )}
        </div>
        {totalCount > usersGridData?.length && usersGridData?.length >= 20 && (
          <div className="d-flex align-items-center justify-content-center">
            <button
              className="btn px-4 color-white font-semibold font-14 primary-btn px-4 rounded-3 text-center"
              onClick={() => {
                handleLoadMore();
              }}
            >
              Load More
            </button>
          </div>
        )}
      </div>
      {deletePopup && (
        <div
          style={{ display: "block" }}
          className="modal fade show"
          id="exampleModal11"
          tabIndex={-1}
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered show  ">
            <div className="modal-content border-radius-10">
              <div className="modal-header border-0 px-4 pt-4 align-items-center">
                <h5
                  className="modal-title font-bold font-18 color-black-v2"
                  id="exampleModalLabel"
                >
                  Confirmation
                </h5>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setDeletePopup(false);
                    setUsersGridData([...tempUsersGridData]);
                    setPrimaryUserData({} as ManageUsersListGridData);
                  }}
                />
              </div>
              <div className="modal-body px-4 py-0">
                <p className="font-medium font-16 mb-0 color-black cust-lh mb-3">
                  Are you sure want to change the primary user?
                </p>
              </div>
              <div className="modal-footer gap-2 border-0 px-4 pb-4 pt-2 justify-content-end">
                <button
                  className="btn tertiary-btn px-4 color-white font-semibold font-14 primary-btn px-4"
                  onClick={() => {
                    setDeletePopup(false);
                    setUsersGridData([...tempUsersGridData]);
                    setPrimaryUserData({} as ManageUsersListGridData);
                  }}
                >
                  No
                </button>
                <button
                  className="btn primary-btn px-4 color-white font-semibold font-14 primary-btn px-4"
                  onClick={() => {
                    deletedInvoiceData();
                  }}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {deletePopup ? <div className="modal-backdrop fade show"></div> : <></>}
      {/* {toastDetails?.isToast && (
        <Toast
          props={{
            isToast: toastDetails?.isToast,
            setToastDetails: setToastDetails,
            toastMessage: toastDetails?.toastMessage,
            toastType: toastDetails?.toastType,
            toastDescription: toastDetails?.toastDescription,
          }}
        />
      )} */}
    </>
  );
};

// PS_32 | SQ_EX_32.0 - Export UsersGrid component
export default UsersGrid;
